import { Box } from '@mui/material';
import { infoContainerSx, infoSectionSx } from '../../styles/Global.style';
import { APP_PATHS } from '../../constants/paths';

export const PVG = () => (
  <Box component="div" sx={infoSectionSx}>
    <Box component="div" sx={infoContainerSx}>
      <h1>
        <strong>PVG Membership and Parent Volunteers</strong>
      </h1>
      <p>
        As a Parent Teacher Association (PTA), we want to make sure all our
        activities are safe, welcoming, and run in line with current
        safeguarding laws. Some PTA roles require membership of the{' '}
        <strong>Protecting Vulnerable Groups (PVG) Scheme</strong>.
      </p>
      <h2>
        <strong>Do all PTA volunteers need PVG membership?</strong>
      </h2>
      <p>
        No. Most parents helping at events (selling tickets, serving
        refreshments, setting up stalls, etc.) will not need PVG membership. A
        PVG check is only needed if your role meets the definition of a{' '}
        <strong>&ldquo;regulated role&rdquo;</strong> under the Disclosure
        (Scotland) Act 2020.
      </p>
      <h3>
        <strong>What counts as a regulated role?</strong>
      </h3>
      <p>
        You may need PVG membership if, as part of your normal duties with the
        PTA, you:
      </p>
      <ul>
        <li>
          <p>
            Are responsible for the{' '}
            <strong>safety and welfare of children</strong>
          </p>
        </li>
        <li>
          <p>
            <strong>Supervise or care for unaccompanied children</strong>
          </p>
        </li>
        <li>
          <p>
            <strong>Teach, coach, or deliver activities</strong> specifically
            for children
          </p>
        </li>
        <li>
          <p>
            <strong>Provide transport</strong> for children on behalf of the PTA
          </p>
        </li>
        <li>
          <p>
            Hold a <strong>position of responsibility</strong> where you make
            decisions about activities or services mainly for children
          </p>
        </li>
      </ul>
      <p>
        One-off or incidental contact with children (for example, helping at a
        stall where children are present with their parents) does not require
        PVG membership.
      </p>
      <p>
        <strong>Examples:</strong>
      </p>
      <p>
        <strong>Roles that usually require PVG membership:</strong>
      </p>
      <ul>
        <li>
          <p>
            Supervising a group of children at a school disco when their parents
            are not present
          </p>
        </li>
        <li>
          <p>
            Running or coaching an after-school sports club organised by the PTA
          </p>
        </li>
        <li>
          <p>
            Delivering workshops or activity sessions directly to children
            (arts, drama, coding, etc.)
          </p>
        </li>
        <li>
          <p>
            Acting as a designated <strong>first aider</strong> at
            children&rsquo;s events on behalf of the PTA
          </p>
        </li>
        <li>
          <p>
            Regularly transporting children to and from events or matches on
            behalf of the PTA
          </p>
        </li>
        <li>
          <p>
            Serving on a PTA sub-committee that runs a{' '}
            <strong>breakfast club</strong> or other childcare provision
          </p>
        </li>
      </ul>
      <p>
        <strong>Roles that usually do not require PVG membership:</strong>
      </p>
      <ul>
        <li>
          <p>
            Selling raffle tickets at a fair or handling money during
            fundraising events
          </p>
        </li>
        <li>
          <p>Organising sponsorship or donations with local businesses</p>
        </li>
        <li>
          <p>
            Serving refreshments at a school disco where teachers and parents
            are present
          </p>
        </li>
        <li>
          <p>Setting up and decorating a hall for an event</p>
        </li>
        <li>
          <p>
            Providing occasional emergency help (e.g. stepping in as first aid
            cover once, unexpectedly)
          </p>
        </li>
        <li>
          <p>
            Giving feedback on school policy as part of Parent Council
            discussions
          </p>
        </li>
        <li>
          <p>
            Acting as treasurer or secretary when your duties are purely
            financial or administrative
          </p>
        </li>
      </ul>
      <h3>
        <strong>How do I apply?</strong>
      </h3>
      <p>
        If you are asked to take on a role that requires PVG membership, the PTA
        will support you through the process. Applications are made through{' '}
        <strong>Volunteer Scotland Disclosure Services (VSDS)</strong>, and for
        qualifying voluntary organisations like PTAs, checks are{' '}
        <strong>free of charge</strong>.
      </p>
      <h3>
        <strong>Why is this important?</strong>
      </h3>
      <p>
        The PVG scheme helps keep children safe by ensuring that unsuitable
        people cannot work or volunteer in regulated roles. It is a legal
        requirement for anyone in a regulated role with children.
      </p>
      <h3>
        <strong>Want to know more?</strong>
      </h3>
      <ul>
        <li>
          <p>
            <a href="https://www.mygov.scot/pvg-scheme">
              Disclosure Scotland &ndash; PVG Scheme
            </a>
          </p>
        </li>
        <li>
          <p>
            <a href="https://www.volunteerscotland.net/disclosure-services/">
              Volunteer Scotland Disclosure Services
            </a>
          </p>
        </li>
        <li>
          <p>
            Full legislation:{' '}
            <a href="https://www.legislation.gov.uk/asp/2020/13/contents">
              Disclosure (Scotland) Act 2020
            </a>
          </p>
        </li>
        <li>
          <p>
            <a href={APP_PATHS.secureHandlingPolicy}>
              Secure Handling Policy of Baljaffray Primary School PTA
            </a>
          </p>
        </li>
        <li>
          <p>
            <a href={APP_PATHS.referralPolicy}>
              Referral Policy of Baljaffray Primary School PTA
            </a>
          </p>
        </li>
      </ul>
      <p>
        If you are unsure whether your PTA role needs PVG membership, please{' '}
        <strong>speak to a member of the PTA committee</strong> by contacting us
        using the email link at the bottom of the page. We&rsquo;ll guide you
        through the next steps.
      </p>
    </Box>
  </Box>
);
